export default {
  Actions: {
    CREATE_COMMENT_SUCCESS: 'comments/CREATE_COMMENT_SUCCESS',
    DELETE_COMMENT_SUCCESS: 'comments/DELETE_COMMENT_SUCCESS',
    UPDATE_COMMENT_SUCCESS: 'comments/UPDATE_COMMENT_SUCCESS',
  },
  State: {
    COMMENTS_BY_SLUG: 'COMMENTS_BY_SLUG',
    COMMENTS_BY_GOAL_SLUG: 'COMMENTS_BY_GOAL_SLUG',
  },
};
